import i18n from '@/main';

const regras = {
    distanciaRaioKm: [
        {
            required: true,
            message: i18n.t('configuracaoParametros.erro.campoDisRKmErro'),
            trigger: 'blur'
        }
    ]
};

export default regras;
